import { InsuranceType, MainPath } from "Constants/constants";

export const PRODUCT_PATH = `/${MainPath.CHECK_PRICE}/${InsuranceType.HOUSE}`;

export const CONSTRUCTION_YEAR_LIMIT_SECURITY_QUESTIONS = 1980;

export const CONSTRUCTION_YEAR_LIMIT_RENTAL = 1970;

export const CONSTRUCTION_YEAR_LIMIT_SUPER = 1924;

export const CONSTRUCTION_YEAR_LIMIT = 1900;

export const OLD_HOUSE_AGE = 50;

export const MAX_BTA = 500;

export const MAX_BTA_RENTAL = 200;

export const DEFAULT_DEDUCTIBLE_HOUSE = "8000";
